export default class NetworkError extends Error {
  constructor(msg: string) {
    super(msg);
  }
}
